import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import App from "../app";

const { appConfig, assetsUrl, page, storeData } = window.asos.loyalty.state;
delete window.asos.loyalty.state;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <App
        appConfig={appConfig}
        storeData={storeData}
        assetsUrl={assetsUrl}
        page={page}
      />
    );
  });
};

start();
